import api from '../utils/api'; // Your centralized axios/api instance

export const universalApi = {
    // 1. Core Production Flow
    // params.include_completed = 0 leaves out rolls / sizes already completed on the line (listed, view only, by default).
    getWorkstationData: (params) => api.get('/workstation-universal/queue', { params }),
    logPieceCheck: (validationData) => api.post('/workstation-universal/log-check', validationData),
    approveAlteredPieces: (data) => api.post('/workstation-universal/approve-repair', data),
    // Supervisor-gated undo: flips an APPROVED piece/bundle back to PENDING.
    revertPieceToPending: (data) => api.post('/workstation-universal/revert-to-pending', data),

    // 2. Global Lookups
    getDefectCodes: () => api.get('/workstation-universal/defect-codes'),

    // 3. Manual Overrides / Reconciliations
    checkAndCompleteStages: (data) => api.post('/workstation-universal/check-roll-completion', data),
    checkStageCompletion: (data) => api.post('/workstation-universal/check-stage-completion', data),

    // ------------------------------------------------------------------------
    // Optional / Future Expansion Routes (Generalized for any department)
    // ------------------------------------------------------------------------
    getAlteredPieces: () => api.get('/workstation-universal/altered-pieces'),
    getCompletedPieces: () => api.get('/workstation-universal/completed-pieces'),
    getPieceDetails: (pieceId) => api.get(`/workstation-universal/piece-details/${pieceId}`),
    getPieceHistory: (pieceId) => api.get(`/workstation-universal/piece-history/${pieceId}`),
    getStatistics: () => api.get('/workstation-universal/statistics'),
    getBatchQCSummary: () => api.get('/workstation-universal/summary'),
    checkCompletion: (data) => api.post('/workstation-universal/check-completion', data),

    // Checker summary: pending rework count + today's rework count
    // approvedDate (optional): the date today_approved_pieces is counted for
    getCheckerStats: (approvedDate) => api.get('/workstation-universal/checker-stats', { params: approvedDate ? { approved_date: approvedDate } : {} }),
    // Today's work log for export (scans done by logged-in user today)
    getTodayWork: (date) => api.get('/workstation-universal/today-work', { params: date ? { date } : {} }),

    // Batch history
    getBatchHistory: (page = 1, limit = 20) => api.get('/workstation-universal/batch-history', { params: { page, limit } }),
    getBatchHistoryDetail: (batchId) => api.get(`/workstation-universal/batch-history/${batchId}`),

    // Rework-backlog thresholds (warning + hard block on plain APPROVE), set via
    // the production_manager settings page — see productionManagerApi.js's
    // getReworkThresholds/setReworkThresholds for the write side.
    getReworkThresholds: () => api.get('/workstation-universal/rework-thresholds'),
};